import { ChakraProvider, Tabs, TabList, Tab, TabPanels, TabPanel, Heading, Flex } from '@chakra-ui/react';
import ApiSettings from './ApiSettings/ApiSettings';
import FormBuilder from './FormBuilder/FormBuilder';
import Enquiry from './Enquiry/Enquiry';
import { Theme } from './Theme';
import MenuPermission from './MenuPermission/MenuPermission';

const Index = () => {
  return <ChakraProvider>
    <Heading>Bonfiglioli Administrator</Heading>
    <Flex m={0} p={0} w={'100%'}>
      <Tabs style={Theme.Tabs}>
        <TabList className="bf-admin-tab-list">
          <Tab className="bf-admin-tab-panels">Api Settings</Tab>
          <Tab className="bf-admin-tab-panels">Forms</Tab>
          <Tab className="bf-admin-tab-panels">Enquiry Matrix</Tab>
          <Tab className="bf-admin-tab-panels">Menu Permissions</Tab>
        </TabList>
        <TabPanels className="bf-admin-tab-panels">
          <TabPanel p={0} className="bf-admin-tab-panel">
            <ApiSettings />
          </TabPanel>
          <TabPanel p={0} className="bf-admin-tab-panel">
            <FormBuilder />
          </TabPanel>
          <TabPanel p={0} className="bf-admin-tab-panel">
            <Enquiry />
          </TabPanel>
          <TabPanel p={0} className="bf-admin-tab-panel">
            <MenuPermission />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Flex>
  </ChakraProvider>
}

export { Index }